import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i538769327__a" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "20",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i538769327__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "M13.988 10.514h-2.76a.719.719 0 0 0-.716.716v2.758a3.478 3.478 0 0 0 3.474 3.475 3.478 3.478 0 0 0 3.475-3.475 3.477 3.477 0 0 0-3.473-3.474Zm2.557 3.474a2.559 2.559 0 0 1-2.557 2.557 2.559 2.559 0 0 1-2.556-2.557v-2.556h2.556a2.559 2.559 0 0 1 2.557 2.556ZM11.19 9.574h2.795c1.942 0 3.52-1.58 3.52-3.52 0-1.939-1.58-3.519-3.52-3.519a3.525 3.525 0 0 0-3.521 3.52v2.793a.73.73 0 0 0 .726.726Zm.204-.928V6.053a2.597 2.597 0 0 1 2.593-2.594 2.597 2.597 0 0 1 2.594 2.594 2.597 2.597 0 0 1-2.594 2.593h-2.593Zm-2.567 1.846H6.051a3.5 3.5 0 0 0-3.496 3.496 3.5 3.5 0 0 0 3.496 3.496 3.502 3.502 0 0 0 3.498-3.496v-2.775a.721.721 0 0 0-.72-.72Zm-.201.922v2.574a2.577 2.577 0 0 1-2.574 2.574 2.576 2.576 0 0 1-2.574-2.574 2.576 2.576 0 0 1 2.574-2.574h2.574ZM8.94 9.686c.41 0 .746-.334.746-.747V6.053A3.637 3.637 0 0 0 6.053 2.42 3.637 3.637 0 0 0 2.42 6.053a3.636 3.636 0 0 0 3.633 3.633h2.886ZM3.37 6.053A2.685 2.685 0 0 1 6.05 3.37a2.685 2.685 0 0 1 2.682 2.682v2.681H6.051a2.685 2.685 0 0 1-2.682-2.681Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "recipetype"}) } }